document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    /**
     * UTM Parameter Capture
     * Reads utm_source, utm_medium, utm_campaign from the URL query string
     * and persists them as cookies. If ANY of the three params are present,
     * ALL three are written — missing ones are set to an empty string so
     * stale values from a previous campaign never linger. (Last-touch.)
     */
    const WHT_UTM_CONFIG = {
        params: ['utm_source', 'utm_medium', 'utm_campaign'],
        cookiePrefix: 'wht_',
        cookieDays: 90,
        cookiePath: '/',
        cookieSameSite: 'Lax'
    };

    function wht_setCookie(name, value, days) {
        try {
            const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
            const isSecure = window.location.protocol === 'https:' ? '; Secure' : '';
            document.cookie =
                `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${WHT_UTM_CONFIG.cookiePath}; SameSite=${WHT_UTM_CONFIG.cookieSameSite}${isSecure}`;
        } catch (err) {
            console.error('[WHT UTM] Failed to set cookie:', name, err);
        }
    }

    function wht_captureUtmParams() {
        let params;
        try {
            params = new URLSearchParams(window.location.search);
        } catch (err) {
            console.error('[WHT UTM] Failed to parse query string:', err);
            return;
        }

        const anyPresent = WHT_UTM_CONFIG.params.some((key) => params.has(key));
        if (!anyPresent) return;

        WHT_UTM_CONFIG.params.forEach((key) => {
            const value = params.get(key)?.trim() ?? '';
            wht_setCookie(WHT_UTM_CONFIG.cookiePrefix + key, value, WHT_UTM_CONFIG.cookieDays);
        });
    }

    wht_captureUtmParams();
});
